<style>
	:global(.inputBox::placeholder) {
		color: rgba(0, 0, 0, 0.6) !important;
	}

	:global(ul) {
		list-style: disc;
	}

	:global(ol) {
		list-style: auto;
	}
</style>

<script lang="ts">
	import Card from '@smui/card';
	import Checkbox from '@smui/checkbox';
	import FormField from '@smui/form-field';
	import Input from '@smui/textfield';
	import Editor from 'cl-editor/src/Editor.svelte';
	import Svelecte from 'svelecte';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
	import NewsMessage from '../../../../shared/models/News/NewsMessage';
	import Sede from '../../../../shared/models/Sede/Sede';
	import { hasRoleAreaManager, hasRoleCompanyManager, hasRoleSysAdmin, userSession } from './../../../../shared/stores';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = NewsMessage.get(params.id);
	let [dataAree, loadingAree, errorAree] = Area.getList();
	let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ idAree: $data.areeId });
	let [dataSedi, loadingSedi, errorSedi] = Sede.getList({ aziendaEnteId: $userSession?.aziendaEnteId });

	if (!$hasRoleSysAdmin) {
		if ($userSession?.areaId && $userSession?.areaId > 0) {
			$data.areeId.push($userSession?.areaId);
		}
		if ($userSession?.aziendaEnteId && $userSession?.aziendaEnteId > 0) {
			$data.aziendeEntiId.push($userSession.aziendaEnteId);
		}
	}

	let aziendeEntiGroupedByArea = [];
	$: if ($dataAree?.response?.length > 0 && $dataAziendeEnti?.response?.length > 0) {
		let aziendeEntiSelected = $dataAziendeEnti.response.filter(function (aziendaEnte) {
			return $data?.areeId?.includes(aziendaEnte.areaId);
		});

		let group_to_values = aziendeEntiSelected?.reduce(function (obj, item) {
			var area = $dataAree.response.find((x) => x.id === item.areaId)?.nomeComune;
			obj[area] = obj[area] || [];
			obj[area].push(item);
			return obj;
		}, {});

		aziendeEntiGroupedByArea = Object.keys(group_to_values).map(function (key) {
			return { groupHeader: key, items: group_to_values[key] };
		});
	}

	$: if ($data.validFrom && $data.validTo) {
		if (new Date($data.validFrom) > new Date($data.validTo)) {
			$data.validFrom = $data.validTo;
		}
	}

	let disabled = true;
	$: if (!$data.validFrom || !$data.validTo || !$data.title || !$data.body) {
		disabled = true;
	} else {
		if (
			($hasRoleSysAdmin && (!$data.areeId || $data.areeId.length == 0)) ||
			($hasRoleCompanyManager && (!$data.sediId || $data.sediId.length == 0))
		) {
			disabled = true;
		} else {
			disabled = false;
		}
	}

	function onSubmit() {
		[data, loading, error] = NewsMessage.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		{#if $hasRoleSysAdmin}
			<Title
				title="News"
				icon="help_outline"
				iconText="Creazione delle news: La sola selezione di una o più aree creerà la news per i rispettivi Area Manager, se invece, oltre la selezione delle aree si seleziona anche una o più aziende/enti, allora la news sarà generata per i rispettivi Company Manager"
			/>
		{:else}
			<Title title="News" />
		{/if}
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button disabled="{disabled}" type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form">
			<div class="md:grid-cols-2 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
				{#if $hasRoleSysAdmin || $hasRoleAreaManager}
					{#if $loadingAree}
						<FieldLoading />
					{:else}
						<Svelecte
							disabled="{$data.id > 0 || !$hasRoleSysAdmin}"
							options="{$dataAree.response}"
							labelField="{'nomeComune'}"
							valueField="{'id'}"
							bind:value="{$data.areeId}"
							multiple
							placeholder="Seleziona aree"
							on:change="{() =>
								([dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ idAree: $data.areeId }))}"
							class="svelecte-control	pt-1.5"
						/>
					{/if}
					{#if $loadingAziendeEnti || $loadingAree}
						<FieldLoading />
					{:else}
							<Svelecte
								disabled="{$data.id > 0 ||
									$data.areeId.length == 0 ||
									(!$hasRoleSysAdmin && !$hasRoleAreaManager)}"
								options="{$data?.areeId?.length > 0 ? aziendeEntiGroupedByArea : []}"
								labelField="{'nomeAziendaEnte'}"
								valueField="{'id'}"
								bind:value="{$data.aziendeEntiId}"
								multiple
								placeholder="Seleziona aziende/enti"
								groupLabelField="groupHeader"
								groupItemsField="items"
								class="svelecte-control	pt-1.5"
							/>
					{/if}
				{:else if $hasRoleCompanyManager}
					{#if $loadingSedi}
						<FieldLoading />
					{:else}
						<Svelecte
							disabled="{$data.id > 0}"
							options="{$data.aziendeEntiId.length > 0 ? $dataSedi.response : []}"
							labelField="{'denominazione'}"
							valueField="{'id'}"
							bind:value="{$data.sediId}"
							multiple
							placeholder="Seleziona sedi"
							class="svelecte-control	pt-1.5"
						/>
					{/if}
				{/if}
			</div>
			<div class="md:grid-cols-2 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
				<FormField>
					<Checkbox bind:checked="{$data.isEnabled}" />
					<span slot="label">Attiva</span>
				</FormField>
				<Input label="Reporter" bind:value="{$data.reporter}" />
				<Input required label="Validità da" bind:value="{$data.validFrom}" type="datetime-local" max="{$data.validTo}" />
				<Input required label="Validità a" bind:value="{$data.validTo}" type="datetime-local" min="{$data.validFrom}" />
				<Input required label="Titolo" bind:value="{$data.title}" />
				<Input label="Sottotitolo" bind:value="{$data.subTitle}" />
			</div>
			<div class="pt-4">
				<Editor bind:html="{$data.body}" on:change="{(evt) => ($data.body = evt.detail)}" />
			</div>
		</form>
	{/if}
</Card>
